import type { SVGProps } from "react";

/**
 * cross-large, crossed large, close
 * @category Interface General
 */
export default function IconCrossLarge(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M4.75 4.75L19.25 19.25M19.25 4.75L4.75 19.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
}
